import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaStatusFinanceiro = (): TabelaColuna => ({
  Chave: 'StatusFinanceiro',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 80 }}>Status Financeiro</div>
})
